import * as Tone from 'tone';

// Resonant biquad filter. Pick LP / HP / BP / notch with a select; tweak
// frequency + Q. The frequency slider uses a 'log' scale hint so the UI can
// map evenly across audible frequencies.

export default {
    id: 'filter',
    name: 'Filt',
    color: '#56b6c2',
    create() {
        const node = new Tone.Filter({ frequency: 1500, type: 'lowpass', Q: 1, rolloff: -24 });
        return {
            node,
            params: [
                { label: 'Type', type: 'select',
                  options: [
                    { value: 'lowpass', label: 'LP' },
                    { value: 'highpass', label: 'HP' },
                    { value: 'bandpass', label: 'BP' },
                    { value: 'notch', label: 'Notch' },
                  ],
                  get: () => node.type, set: v => { node.type = v; } },
                { label: 'Freq', unit: 'Hz', min: 60, max: 20000, step: 1, scale: 'log',
                  get: () => node.frequency.value, set: v => { node.frequency.value = v; } },
                { label: 'Q', min: 0.1, max: 12, step: 0.1,
                  get: () => node.Q.value, set: v => { node.Q.value = v; } },
            ],
            dispose() { node.dispose(); },
        };
    },
};
